module.exports = __webpack_public_path__ + "assets/white_plus-43e5a0.svg";